import { render, staticRenderFns } from "./AdminUtentiView.vue?vue&type=template&id=244a7ff6&"
import script from "./AdminUtentiView.vue?vue&type=script&lang=ts&"
export * from "./AdminUtentiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports